import { render, staticRenderFns } from "./TakipAltTipiPicker.vue?vue&type=template&id=1f599997"
import script from "./TakipAltTipiPicker.vue?vue&type=script&lang=ts"
export * from "./TakipAltTipiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports